/**
 *
 * Styles for SegmentControl
 *
 */

import styled, { css } from "styled-components";
import { key } from "styled-theme";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const SegmentControlWrapper = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  list-style-type: none;
  box-shadow: var(--gaq-size-space--5px) var(--gaq-size-space-5px)
    var(--dui-size-space-4x) var(--gaq-size-space--5px)
    var(--dui-color-gray-300);
  margin-bottom: 0;
`;

const activeBorderSize = css`var(--dui-size-3x)`;

export const SegmentedListButton = styled.button`
  list-style: none;
  flex: 1 0 ${(props) => 100 / props.numberOfTabs}%;
  position: relative;

  border: none;
  box-shadow: var(--dui-size-space-1x) var(--dui-size-space-0)
    var(--dui-size-space-4x) var(--gaq-size-space--3px)
    var(--dui-color-gray-300);
  transition: border-top 100ms ease-in-out;
  font-weight: 600;
  font-stretch: condensed;
  padding: var(--dui-size-space-6x) var(--dui-size-space-3x);

  font-size: ${key("fonts.mobile.tabs.size")};
  line-height: ${key("fonts.mobile.tabs.lineHeight")};
  text-align: center;

  @media screen and (min-width: ${breakpoints.tablet}) {
    min-width: 205px;
    flex: inherit;
  }

  &:last-child {
    border-left: 0;
  }

  @media print {
    display: none;
  }
  border-top: ${activeBorderSize} solid transparent;
  background-color: var(--dui-color-black-opacity-05);
  color: var(--dui-color-black-500);

  &[aria-selected="true"] {
    background-color: var(--dui-color-white-500);
    color: var(--dui-color-red-500);
  }
  &:after {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(-1 * ${activeBorderSize});
    border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-500);
    transition: border-top 100ms ease-in-out;
    content: "";
  }

  &[aria-selected="true"]:after {
    border-top: ${activeBorderSize} solid var(--dui-color-red-500);
  }

  & > span {
    padding: var(--dui-size-space-2x) var(--gaq-size-space-3px)
      var(--dui-size-space-1);
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    font-size: var(--dui-size-font-md);
    line-height: 26px;
    padding: var(--dui-size-space-7x) var(--dui-size-space-10x);
    &:focus > span {
      background-color: var(--dui-color-red-500);
      color: var(--dui-color-white-500);
    }
  }
`;
